export default "__VITE_ASSET__fcbc04d8__"